
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"8.316","height":"15.874"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.925.001a.367.367 0 00-.26.114L.111 7.669a.378.378 0 000 .534l7.555 7.555a.378.378 0 10.534-.534L.912 7.936 8.2.649a.377.377 0 00.084-.418.373.373 0 00-.359-.23z","fill":"#38470b"}})])
          )
        }
      }
    